import {Grid, Typography} from '@logistics-frontend/blocks';
import React from 'react';

import ArrowIcon from '../icons/ArrowIcon';
import FooterLogoIcon from '../icons/FooterLogoIcon';
import {logoClasses} from './FooterLogo@mobile.classes';

export type FooterLogoProps = {
  phrase1: string | JSX.Element
}

export function FooterLogoMobile({phrase1}: FooterLogoProps) {
  return (
    <Grid direction="column" container>
      <Grid className={logoClasses.gap} direction="column" container>
        <Typography className={logoClasses.phrase} color="invert" thickness="regular" variant="title2">
          {phrase1}
        </Typography>
        <Grid alignItems="center" container item>
          <ArrowIcon className={logoClasses.arrow} />
          <FooterLogoIcon className={logoClasses.logo} />
        </Grid>
      </Grid>
    </Grid>
  )
}
